module.exports = __webpack_public_path__ + "static/media/icita2023.37a0972d.png";